import React from 'react';
import { Avatar } from 'primereact/avatar';

const Dashboard: React.FC = () => {
  // Sample data
  const cashflowData = [
    { month: 'Jan', income: 6000, expense: 4000 },
    { month: 'Feb', income: 5500, expense: 5000 },
    { month: 'Mar', income: 6800, expense: 3500 },
    { month: 'Apr', income: 7200, expense: 4200 },
    { month: 'May', income: 6500, expense: 5500 },
    { month: 'Jun', income: 7500, expense: 5000 },
    { month: 'Jul', income: 5800, expense: 4800 },
    { month: 'Aug', income: 6200, expense: 5200 },
    { month: 'Sep', income: 7000, expense: 5800 },
    { month: 'Oct', income: 6800, expense: 6000 },
    { month: 'Nov', income: 5500, expense: 6500 },
    { month: 'Dec', income: 6500, expense: 4500 },
  ];

  const transactions = [
    { name: 'Electricity Bill', category: 'Payments', date: '2028-03-01', time: '04:28:48', amount: 295.81, note: 'Payment for monthly electricity bill', status: 'Failed' },
    { name: 'Weekly Groceries', category: 'Shopping', date: '2028-03-04', time: '04:28:48', amount: 204.07, note: 'Groceries shopping at local supermarket', status: 'Completed' },
    { name: 'Movie Night', category: 'Entertainment', date: '2028-02-27', time: '04:28:48', amount: 97.84, note: 'Tickets for movies and snacks', status: 'Pending' },
    { name: 'Medical Check-up', category: 'Healthcare', date: '2028-02-07', time: '04:28:48', amount: 323.33, note: 'Routine health check-up and medications', status: 'Pending' },
    { name: 'Dinner at Italian Restaurant', category: 'Dining Out', date: '2028-02-11', time: '04:28:48', amount: 226.25, note: 'Dining out with family at a local Italian restaurant', status: 'Pending' },
  ];

  const maxValue = Math.max(...cashflowData.map(d => Math.max(d.income, d.expense)));

  return (
    <div style={{ 
      padding: '0',
      minHeight: '100vh',
      margin: '0 auto'
    }}>
      {/* Hero Header with Gradient - Consistent with Branches */}
      <div style={{
        background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 50%, #0a2f2f 100%)',
        borderRadius: '20px',
        padding: '32px',
        marginBottom: '24px',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 10px 40px rgba(15, 61, 62, 0.3)'
      }}>
        {/* Decorative elements */}
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          background: 'rgba(212, 241, 126, 0.1)',
          borderRadius: '50%',
          filter: 'blur(40px)'
        }} />
        <div style={{
          position: 'absolute',
          bottom: '-80px',
          left: '-80px',
          width: '250px',
          height: '250px',
          background: 'rgba(212, 241, 126, 0.08)',
          borderRadius: '50%',
          filter: 'blur(50px)'
        }} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'inline-block',
            padding: '5px 12px',
            background: 'rgba(212, 241, 126, 0.2)',
            borderRadius: '20px',
            marginBottom: '10px',
            fontSize: '0.7rem',
            fontWeight: '600',
            letterSpacing: '0.5px',
            textTransform: 'uppercase'
          }}>
            Super Admin Dashboard
          </div>
          <h1 style={{
            margin: '0 0 8px 0',
            fontSize: '1.7rem',
            fontWeight: '700',
            color: 'white',
            letterSpacing: '-0.5px'
          }}>
            Overview
          </h1>
          <p style={{
            margin: '0',
            color: 'rgba(255,255,255,0.8)',
            fontSize: '0.9rem'
          }}>
            Monitor your platform performance and key metrics
          </p>
        </div>
      </div>

      {/* Stats Grid - 4 columns */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(4, 1fr)', 
        gap: '16px',
        marginBottom: '24px'
      }}>
        {/* Branches Card */}
        <div style={{
          background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 50%, #0a2f2f 100%)',
          borderRadius: '16px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(15, 61, 62, 0.2)',
          position: 'relative',
          overflow: 'hidden',
          color: 'white'
        }}>
          <div style={{
            position: 'absolute',
            top: '-30px',
            right: '-30px',
            width: '120px',
            height: '120px',
            background: 'rgba(212, 241, 126, 0.15)',
            borderRadius: '50%',
            filter: 'blur(30px)'
          }} />
          
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div style={{
                width: '44px',
                height: '44px',
                background: 'rgba(212, 241, 126, 0.2)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="pi pi-building" style={{ fontSize: '1.1rem', color: '#d4f17e' }}></i>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '5px 12px',
                background: 'rgba(74, 222, 128, 0.2)',
                borderRadius: '14px'
              }}>
                <i className="pi pi-arrow-up" style={{ fontSize: '0.7rem', color: '#4ade80' }}></i>
                <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#4ade80' }}>
                  +12.5%
                </span>
              </div>
            </div>

            <h2 style={{ 
              margin: '0 0 6px 0', 
              fontSize: '2rem', 
              fontWeight: '700',
              color: 'white',
              letterSpacing: '-0.5px'
            }}>
              145
            </h2>

            <p style={{ 
              margin: '0 0 18px 0', 
              fontSize: '0.85rem', 
              color: 'rgba(255,255,255,0.8)',
              fontWeight: '500'
            }}>
              Total Branches
            </p>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              paddingTop: '16px',
              borderTop: '1px solid rgba(255,255,255,0.15)'
            }}>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Active</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#4ade80', fontWeight: '700' }}>128</p>
              </div>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Inactive</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#f87171', fontWeight: '700' }}>17</p>
              </div>
            </div>
          </div>
        </div>

        {/* Courses Card */}
        <div style={{
          background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 50%, #0a2f2f 100%)',
          borderRadius: '16px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(15, 61, 62, 0.2)',
          position: 'relative',
          overflow: 'hidden',
          color: 'white'
        }}>
          <div style={{
            position: 'absolute',
            top: '-30px',
            right: '-30px',
            width: '120px',
            height: '120px',
            background: 'rgba(212, 241, 126, 0.15)',
            borderRadius: '50%',
            filter: 'blur(30px)'
          }} />

          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div style={{
                width: '44px',
                height: '44px',
                background: 'rgba(212, 241, 126, 0.2)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="pi pi-book" style={{ fontSize: '1.1rem', color: '#d4f17e' }}></i>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '5px 12px',
                background: 'rgba(74, 222, 128, 0.2)',
                borderRadius: '14px'
              }}>
                <i className="pi pi-arrow-up" style={{ fontSize: '0.7rem', color: '#4ade80' }}></i>
                <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#4ade80' }}>
                  +8.3%
                </span>
              </div>
            </div>

            <h2 style={{ margin: '0 0 6px 0', fontSize: '2rem', fontWeight: '700', color: 'white', letterSpacing: '-0.5px' }}>
              342
            </h2>
            <p style={{ margin: '0 0 18px 0', fontSize: '0.85rem', color: 'rgba(255,255,255,0.8)', fontWeight: '500' }}>
              Total Courses
            </p>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              paddingTop: '16px',
              borderTop: '1px solid rgba(255,255,255,0.15)'
            }}>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Active</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#4ade80', fontWeight: '700' }}>298</p>
              </div>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Draft</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#fbbf24', fontWeight: '700' }}>44</p>
              </div>
            </div>
          </div>
        </div>

        {/* License Stats Card */}
        <div style={{
          background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 50%, #0a2f2f 100%)',
          borderRadius: '16px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(15, 61, 62, 0.2)',
          position: 'relative',
          overflow: 'hidden',
          color: 'white'
        }}>
          <div style={{
            position: 'absolute',
            top: '-30px',
            right: '-30px',
            width: '120px',
            height: '120px',
            background: 'rgba(212, 241, 126, 0.15)',
            borderRadius: '50%',
            filter: 'blur(30px)'
          }} />

          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div style={{
                width: '44px',
                height: '44px',
                background: 'rgba(212, 241, 126, 0.2)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="pi pi-shield" style={{ fontSize: '1.1rem', color: '#d4f17e' }}></i>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '5px 12px',
                background: 'rgba(248, 113, 113, 0.2)',
                borderRadius: '14px'
              }}>
                <i className="pi pi-arrow-down" style={{ fontSize: '0.7rem', color: '#f87171' }}></i>
                <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#f87171' }}>
                  -5.2%
                </span>
              </div>
            </div>

            <h2 style={{ margin: '0 0 6px 0', fontSize: '2rem', fontWeight: '700', color: 'white', letterSpacing: '-0.5px' }}>
              89
            </h2>
            <p style={{ margin: '0 0 18px 0', fontSize: '0.85rem', color: 'rgba(255,255,255,0.8)', fontWeight: '500' }}>
              Branch Licenses
            </p>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              paddingTop: '16px',
              borderTop: '1px solid rgba(255,255,255,0.15)'
            }}>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Valid</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#4ade80', fontWeight: '700' }}>72</p>
              </div>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Expired</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#f87171', fontWeight: '700' }}>17</p>
              </div>
            </div>
          </div>
        </div>

        {/* Batches Card */}
        <div style={{
          background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 50%, #0a2f2f 100%)',
          borderRadius: '16px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(15, 61, 62, 0.2)',
          position: 'relative',
          overflow: 'hidden',
          color: 'white'
        }}>
          <div style={{
            position: 'absolute',
            top: '-30px',
            right: '-30px',
            width: '120px',
            height: '120px',
            background: 'rgba(212, 241, 126, 0.15)',
            borderRadius: '50%',
            filter: 'blur(30px)'
          }} />

          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div style={{
                width: '44px',
                height: '44px',
                background: 'rgba(212, 241, 126, 0.2)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="pi pi-users" style={{ fontSize: '1.1rem', color: '#d4f17e' }}></i>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '5px 12px',
                background: 'rgba(74, 222, 128, 0.2)',
                borderRadius: '14px'
              }}>
                <i className="pi pi-arrow-up" style={{ fontSize: '0.7rem', color: '#4ade80' }}></i>
                <span style={{ fontSize: '0.75rem', fontWeight: '600', color: '#4ade80' }}>
                  +15.7%
                </span>
              </div>
            </div>

            <h2 style={{ margin: '0 0 6px 0', fontSize: '2rem', fontWeight: '700', color: 'white', letterSpacing: '-0.5px' }}>
              456
            </h2>
            <p style={{ margin: '0 0 18px 0', fontSize: '0.85rem', color: 'rgba(255,255,255,0.8)', fontWeight: '500' }}>
              Total Batches
            </p>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              paddingTop: '16px',
              borderTop: '1px solid rgba(255,255,255,0.15)'
            }}>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Ongoing</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#4ade80', fontWeight: '700' }}>389</p>
              </div>
              <div>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Completed</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#94a3b8', fontWeight: '700' }}>67</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Row */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 380px',
        gap: '20px'
      }}>
        {/* Left Side - Cashflow and Transactions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Cashflow Chart */}
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <h3 style={{ margin: '0 0 4px 0', fontSize: '1rem', fontWeight: '700', color: '#0f3d3e' }}>
                  Cashflow
                </h3>
                <p style={{ margin: 0, fontSize: '0.75rem', color: '#999' }}>
                  Income vs Expense tracking
                </p>
              </div>
              <select style={{
                background: '#f8f9fa',
                border: 'none',
                borderRadius: '10px',
                padding: '10px 36px 10px 14px',
                fontSize: '0.8rem',
                fontWeight: '600',
                color: '#0f3d3e',
                cursor: 'pointer',
                appearance: 'none',
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%230f3d3e' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 14px center'
              }}>
                <option>This Year</option>
                <option>Last Year</option>
              </select>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <p style={{ margin: '0 0 4px 0', fontSize: '0.7rem', color: '#999', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Total Balance
              </p>
              <h2 style={{ margin: 0, fontSize: '1.8rem', fontWeight: '700', color: '#0f3d3e', letterSpacing: '-0.5px' }}>
                $562,000
              </h2>
            </div>

            {/* Chart */}
            <div style={{ position: 'relative', height: '220px', marginBottom: '20px' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                height: '100%',
                gap: '6px',
                padding: '16px 0'
              }}>
                {cashflowData.map((data, idx) => {
                  const incomeHeight = (data.income / maxValue) * 100;
                  const expenseHeight = (data.expense / maxValue) * 100;
                  
                  return (
                    <div key={idx} style={{ 
                      flex: 1, 
                      display: 'flex', 
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '6px',
                      height: '100%',
                      justifyContent: 'flex-end'
                    }}>
                      <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        gap: '3px',
                        width: '100%',
                        alignItems: 'center'
                      }}>
                        <div style={{
                          width: '100%',
                          height: `${incomeHeight}%`,
                          background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 100%)',
                          borderRadius: '8px 8px 0 0',
                          minHeight: '12px',
                          maxHeight: '180px',
                          transition: 'all 0.3s ease'
                        }} />
                        <div style={{
                          width: '100%',
                          height: `${expenseHeight}%`,
                          background: '#d4f17e',
                          borderRadius: '0 0 8px 8px',
                          minHeight: '12px',
                          maxHeight: '180px',
                          transition: 'all 0.3s ease'
                        }} />
                      </div>
                      <span style={{ fontSize: '0.7rem', color: '#999', fontWeight: '600', marginTop: '6px' }}>
                        {data.month}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ 
              display: 'flex', 
              gap: '24px', 
              justifyContent: 'center',
              padding: '16px',
              background: '#f8f9fa',
              borderRadius: '10px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ 
                  width: '14px', 
                  height: '14px', 
                  background: 'linear-gradient(135deg, #0f3d3e 0%, #1a5555 100%)', 
                  borderRadius: '4px' 
                }} />
                <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>Income</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '14px', height: '14px', background: '#d4f17e', borderRadius: '4px' }} />
                <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>Expense</span>
              </div>
            </div>
          </div>

          {/* Recent Transactions */}
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <h3 style={{ margin: '0 0 4px 0', fontSize: '1rem', fontWeight: '700', color: '#0f3d3e' }}>
                  Recent Transactions
                </h3>
                <p style={{ margin: 0, fontSize: '0.75rem', color: '#999' }}>
                  Latest payment activities
                </p>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <select style={{
                  background: '#f8f9fa',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 36px 10px 14px',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#0f3d3e',
                  cursor: 'pointer',
                  appearance: 'none',
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%230f3d3e' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 14px center'
                }}>
                  <option>This Month</option>
                  <option>Last Month</option>
                </select>
              </div>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #f0f0f0' }}>
                    {['Transaction Name', 'Date & Time', 'Amount', 'Note', 'Status'].map((header, idx) => (
                      <th key={idx} style={{
                        textAlign: 'left',
                        padding: '12px 12px',
                        fontSize: '0.7rem',
                        fontWeight: '700',
                        color: '#999',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction, idx) => (
                    <tr key={idx} style={{ 
                      borderBottom: idx < transactions.length - 1 ? '1px solid #f8f9fa' : 'none',
                      transition: 'background 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#f8f9fa';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                    }}>
                      <td style={{ padding: '16px 12px' }}>
                        <div>
                          <p style={{ margin: '0 0 4px 0', fontSize: '0.85rem', fontWeight: '600', color: '#0f3d3e' }}>
                            {transaction.name}
                          </p>
                          <p style={{ margin: 0, fontSize: '0.7rem', color: '#999', fontWeight: '500' }}>
                            {transaction.category}
                          </p>
                        </div>
                      </td>
                      <td style={{ padding: '16px 12px' }}>
                        <div>
                          <p style={{ margin: '0 0 4px 0', fontSize: '0.8rem', fontWeight: '600', color: '#666' }}>
                            {transaction.date}
                          </p>
                          <p style={{ margin: 0, fontSize: '0.7rem', color: '#999' }}>
                            {transaction.time}
                          </p>
                        </div>
                      </td>
                      <td style={{ padding: '16px 12px' }}>
                        <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e', fontFamily: 'monospace' }}>
                          ${transaction.amount}
                        </span>
                      </td>
                      <td style={{ padding: '16px 12px', maxWidth: '200px' }}>
                        <p style={{ margin: 0, fontSize: '0.75rem', color: '#999', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {transaction.note}
                        </p>
                      </td>
                      <td style={{ padding: '16px 12px' }}>
                        <span style={{
                          padding: '6px 14px',
                          borderRadius: '12px',
                          fontSize: '0.7rem',
                          fontWeight: '600',
                          background: transaction.status === 'Completed' ? 'rgba(74, 222, 128, 0.1)' : transaction.status === 'Pending' ? 'rgba(251, 191, 36, 0.1)' : 'rgba(248, 113, 113, 0.1)',
                          color: transaction.status === 'Completed' ? '#4ade80' : transaction.status === 'Pending' ? '#fbbf24' : '#f87171',
                          display: 'inline-block',
                          textTransform: 'uppercase',
                          letterSpacing: '0.3px'
                        }}>
                          {transaction.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Right Side - Statistics */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Statistics Card */}
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <div>
                <h3 style={{ margin: '0 0 4px 0', fontSize: '1rem', fontWeight: '700', color: '#0f3d3e' }}>
                  Statistics
                </h3>
                <p style={{ margin: 0, fontSize: '0.75rem', color: '#999' }}>
                  Teachers & Students overview
                </p>
              </div>
              <select style={{
                background: '#f8f9fa',
                border: 'none',
                borderRadius: '10px',
                padding: '10px 36px 10px 14px',
                fontSize: '0.8rem',
                fontWeight: '600',
                color: '#0f3d3e',
                cursor: 'pointer',
                appearance: 'none',
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%230f3d3e' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 14px center'
              }}>
                <option>This Month</option>
                <option>Last Month</option>
              </select>
            </div>

            {/* Teachers Section */}
            <div style={{ marginBottom: '40px' }}>
              <h4 style={{ margin: '0 0 20px 0', fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>
                Teachers
              </h4>
              
              <div style={{ 
                width: '180px', 
                height: '180px', 
                margin: '0 auto 20px',
              }}>
                <svg viewBox="0 0 200 200" style={{ transform: 'rotate(-90deg)' }}>
                  {/* Active Teachers - 65% */}
                  <circle
                    cx="100"
                    cy="100"
                    r="40"
                    fill="transparent"
                    stroke="#0f3d3e"
                    strokeWidth="32"
                    strokeDasharray="163.363 87.964"
                    strokeDashoffset="0"
                    strokeLinecap="round"
                  />
                  {/* On Leave - 20% */}
                  <circle
                    cx="100"
                    cy="100"
                    r="40"
                    fill="transparent"
                    stroke="#fbbf24"
                    strokeWidth="32"
                    strokeDasharray="50.265 201.062"
                    strokeDashoffset="-163.363"
                    strokeLinecap="round"
                  />
                  {/* Inactive - 15% */}
                  <circle
                    cx="100"
                    cy="100"
                    r="40"
                    fill="transparent"
                    stroke="#f87171"
                    strokeWidth="32"
                    strokeDasharray="37.699 213.628"
                    strokeDashoffset="-213.628"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              {/* Total below the chart */}
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <p style={{ margin: '0 0 6px 0', fontSize: '0.7rem', color: '#999', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Total
                </p>
                <h3 style={{ margin: 0, fontSize: '2rem', fontWeight: '700', color: '#0f3d3e', letterSpacing: '-0.5px' }}>
                  1,247
                </h3>
              </div>

              {/* Teachers Legend */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '14px', height: '14px', background: '#0f3d3e', borderRadius: '3px' }} />
                    <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>Active</span>
                  </div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>811 (65%)</span>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: '7px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ width: '65%', height: '100%', background: '#0f3d3e', borderRadius: '4px' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '4px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '14px', height: '14px', background: '#fbbf24', borderRadius: '3px' }} />
                    <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>On Leave</span>
                  </div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>249 (20%)</span>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: '7px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ width: '20%', height: '100%', background: '#fbbf24', borderRadius: '4px' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '4px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '14px', height: '14px', background: '#f87171', borderRadius: '3px' }} />
                    <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>Inactive</span>
                  </div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>187 (15%)</span>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: '7px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ width: '15%', height: '100%', background: '#f87171', borderRadius: '4px' }} />
                </div>
              </div>
            </div>

            {/* Divider */}
            <div style={{ 
              height: '1px', 
              background: '#f0f0f0', 
              margin: '36px 0' 
            }} />

            {/* Students Section */}
            <div>
              <h4 style={{ margin: '0 0 20px 0', fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>
                Students
              </h4>
              
              <div style={{ 
                width: '180px', 
                height: '180px', 
                margin: '0 auto 20px',
              }}>
                <svg viewBox="0 0 200 200" style={{ transform: 'rotate(-90deg)' }}>
                  {/* Enrolled - 72% */}
                  <circle
                    cx="100"
                    cy="100"
                    r="40"
                    fill="transparent"
                    stroke="#0f3d3e"
                    strokeWidth="32"
                    strokeDasharray="180.956 70.371"
                    strokeDashoffset="0"
                    strokeLinecap="round"
                  />
                  {/* Graduated - 18% */}
                  <circle
                    cx="100"
                    cy="100"
                    r="40"
                    fill="transparent"
                    stroke="#4ade80"
                    strokeWidth="32"
                    strokeDasharray="45.239 206.088"
                    strokeDashoffset="-180.956"
                    strokeLinecap="round"
                  />
                  {/* Dropped - 10% */}
                  <circle
                    cx="100"
                    cy="100"
                    r="40"
                    fill="transparent"
                    stroke="#94a3b8"
                    strokeWidth="32"
                    strokeDasharray="25.133 226.194"
                    strokeDashoffset="-226.195"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              {/* Total below the chart */}
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <p style={{ margin: '0 0 6px 0', fontSize: '0.7rem', color: '#999', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  Total
                </p>
                <h3 style={{ margin: 0, fontSize: '2rem', fontWeight: '700', color: '#0f3d3e', letterSpacing: '-0.5px' }}>
                  8,542
                </h3>
              </div>

              {/* Students Legend */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '14px', height: '14px', background: '#0f3d3e', borderRadius: '3px' }} />
                    <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>Enrolled</span>
                  </div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>6,150 (72%)</span>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: '7px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ width: '72%', height: '100%', background: '#0f3d3e', borderRadius: '4px' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '4px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '14px', height: '14px', background: '#4ade80', borderRadius: '3px' }} />
                    <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>Graduated</span>
                  </div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>1,538 (18%)</span>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: '7px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ width: '18%', height: '100%', background: '#4ade80', borderRadius: '4px' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '4px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '14px', height: '14px', background: '#94a3b8', borderRadius: '3px' }} />
                    <span style={{ fontSize: '0.8rem', color: '#666', fontWeight: '600' }}>Dropped</span>
                  </div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f3d3e' }}>854 (10%)</span>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: '7px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ width: '10%', height: '100%', background: '#94a3b8', borderRadius: '4px' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;